import { render } from "./TransitionFadeDownCss.vue?vue&type=template&id=203bb900"
import script from "./TransitionFadeDownCss.vue?vue&type=script&lang=js"
export * from "./TransitionFadeDownCss.vue?vue&type=script&lang=js"

import "./TransitionFadeDownCss.vue?vue&type=style&index=0&id=203bb900&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__